import {BrowserModule} from '@angular/platform-browser';
import {TranslateModule, TranslateLoader} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {AppComponent} from './app.component';
import {IcListComponent} from './components/ic-list/ic-list.component';
import {
  HighlightSearch,
  IcGridItemComponent
} from './components/cards/design-solution-item/design-solution-item.component';
import {NavCatalogComponent} from './components/nav-catalog/nav-catalog.component';
import {FeaturesRecapViewComponent} from './components/specification/features/features-recap/features-recap.component';
import {MainContentComponent} from './components/main-content/main-content.component';
import {SelectedDesignComponent} from './components/selected-design/selected-design.component';
import {IcGridComponent} from './components/ic-grid/ic-grid.component';
import {AcDcSpecificationViewComponent} from './solution-type/POWER/acdc/specification-view/specification-view.component';
import {FlexLayoutModule} from '@angular/flex-layout';
import {DevToolsExtension, NgRedux, NgReduxModule} from '@angular-redux/store';
import {ActionsService} from './Redux/Actions/actions.service';
import {LoadCatalogEpics} from './Redux/Middlewares/catalog-load';
import {LoadProjectTypesEpics} from './Redux/Middlewares/project-types-load';
import {ISelectorState, SELECTOR_STATE_INIT} from './Redux/selector.state';
import {selectorRootReducer} from './Redux/Reducers/selector';
import {combineEpics, createEpicMiddleware} from 'redux-observable-es6-compat';
import {environment} from '../environments/environment';
import {AuthGuard, eSelectorRouterModule} from './app.router';
import {HashLocationStrategy, LocationStrategy} from '@angular/common';
import {NgReduxRouter, NgReduxRouterModule} from '@angular-redux/router';
import {PresetComponent} from './components/specification/v-input/preset/preset.component';
import {DcDcSpecificationViewComponent} from './solution-type/POWER/dcdc/specification-view/specification-view.component';
import {UnableSuitableDesignComponent} from './components/unable-suitable-design/unable-suitable-design.component';
import {TestSpecificationViewComponent} from "./solution-type/test/specification-view/specification-view.component";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {VInputComponent} from './components/specification/v-input/v-input.component';
import {GlobalStateComponent} from './components/specification/global-state/global-state.component';
import {VOutputComponent} from './components/specification/v-output/v-output.component';
import {FeatureItemComponent} from './components/specification/features/feature-item/feature-item.component';
import {DesignSolutionSelectedComponent} from './components/cards/design-solution-selected/design-solution-selected.component';
import {AcceptSortSolutionsEpics} from "./Redux/Middlewares/accept_sort_solutions";
import {ValidationSpecsEpics} from "./Redux/Middlewares/validation_specs";
import {AutoFormatPipe} from './common/pipe/auto-format.pipe';
import {TestsEpics} from "./Redux/Middlewares/tests";
import {LedDcDcSpecificationViewComponent} from "./solution-type/LED/dcdc/specification-view/specification-view.component";
import {LedAcDcSpecificationViewComponent} from "./solution-type/LED/acdc/specification-view/specification-view.component";
import {RedirectToEdsComponent} from './components/redirect-to-eds/redirect-to-eds.component';
import {EDSngCustomMaterialModuleModule} from "./e-dsng-custom-material-module/e-dsng-custom-material-module.module";
import {EDSngMediaService} from "./components/edsng-media.service";
import {UserProjectsTableComponent} from './components/nav-catalog/user-projects-table/user-projects-table.component';
import {LoadUserInfoEpics} from "./Redux/Middlewares/user-info-load";
import {DesignTableComponent} from './components/ic-list/design-table/design-table.component';
import {MessageDlgComponent} from './components/nav-catalog/message-dlg/message-dlg.component';
import {AppInfoComponent} from './components/app-info/app-info.component';
import {LedPreselectDialogComponent} from './components/specification/v-output/led-preselect-dialog/led-preselect-dialog.component';
import {LedInfoComponent} from './components/specification/v-output/led-preselect-dialog/led-info/led-info.component';
import {ParseFromWidgetComponent} from './components/parse-from-widget/parse-from-widget.component';
import {HeaderComponent} from './components/header/header.component';
import {ErrorComponent} from './components/error/error.component';
import {AnalyticsEpics} from './Redux/Middlewares/analytics';
import {SidebarComponent} from './components/sidebar/sidebar.component';
import {UserProjectsActionsDialogComponent} from './components/nav-catalog/user-projects-actions-dialog/user-projects-actions-dialog.component';
import {CollectionsComponent} from './components/collections/collections.component';
import {TrimPipe} from 'app/common/pipe/removeSpace.pipe';
import {FeatureDialogComponent} from './components/specification/features/feature-dialog/feature-dialog.component';
import {SpinnerComponent} from './components/spinner/spinner.component';
import {WelcomePageComponent} from './components/welcome-page/welcome-page.component';
import {HelpPageComponent} from './components/help-page/help-page.component';
import {RenameResourceDialogComponent} from "./components/nav-catalog/user-projects-table/rename-resource-dialog/rename-resource-dialog.component";
import {ResetSpecsService} from "./components/reset-specs.service";
import {HttpClientModule, HttpClient} from "@angular/common/http";
import {ConfirmImportDlgComponent} from './components/nav-catalog/confirm-import-dlg/confirm-import-dlg.component';
import {NgxSliderModule} from "@angular-slider/ngx-slider";
import {InViewportModule} from "ng-in-viewport";
import {SupportComponent} from './components/support/support.component';
import { ToolbarComponent } from './components/toolbar/toolbar.component';
import { HomePageComponent } from './components/home-page/home-page.component';
import { BasicCardComponent } from './components/cards/basic-card/basic-card.component';
import { MultiActionCardComponent } from './components/cards/multi-action-card/multi-action-card.component';
import { SelectButtonComponent } from './components/select-button/select-button.component';
import { BreadcrumbSelectionComponent } from './components/breadcrumb-selection/breadcrumb-selection.component';
import {SafeHtmlPipe} from "./common/pipe/safeHtml.pipe";
import {AuthService} from "./auth/auth.service";
import {HackathonPageComponent} from "./components/hackathon-page/hackathon-page.component";
import {
  ConfirmDownloadDlgComponent,
} from "./components/hackathon-page/confirm-download-dlg/confirm-download-dlg.component";

// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, `${window.location.pathname}assets/i18n/`, ".json");
}

@NgModule({
  declarations: [
    AppComponent,
    IcListComponent,
    IcGridItemComponent,
    NavCatalogComponent,
    FeaturesRecapViewComponent,
    MainContentComponent,
    SelectedDesignComponent,
    IcGridComponent,
    AcDcSpecificationViewComponent,
    DcDcSpecificationViewComponent,
    LedAcDcSpecificationViewComponent,
    LedDcDcSpecificationViewComponent,
    TestSpecificationViewComponent,
    PresetComponent,
    UnableSuitableDesignComponent,
    VInputComponent,
    GlobalStateComponent,
    VOutputComponent,
    FeatureItemComponent,
    DesignSolutionSelectedComponent,
    AutoFormatPipe,
    RedirectToEdsComponent,
    UserProjectsTableComponent,
    DesignTableComponent,
    MessageDlgComponent,
    AppInfoComponent,
    LedPreselectDialogComponent,
    LedInfoComponent,
    ParseFromWidgetComponent,
    HeaderComponent,
    ErrorComponent,
    SidebarComponent,
    UserProjectsActionsDialogComponent,
    CollectionsComponent,
    TrimPipe,
    FeatureDialogComponent,
    SpinnerComponent,
    WelcomePageComponent,
    RenameResourceDialogComponent,
    HelpPageComponent,
    HackathonPageComponent,
    ConfirmImportDlgComponent,
    ConfirmDownloadDlgComponent,
    HighlightSearch,
    SupportComponent,
    ToolbarComponent,
    HomePageComponent,
    BasicCardComponent,
    MultiActionCardComponent,
    SelectButtonComponent,
    BreadcrumbSelectionComponent,
    SafeHtmlPipe
  ],
  entryComponents: [
    ConfirmImportDlgComponent,
    ConfirmDownloadDlgComponent,
    MessageDlgComponent,
    LedPreselectDialogComponent,
    UserProjectsActionsDialogComponent,
    RenameResourceDialogComponent,
    FeatureDialogComponent
  ],
  exports: [
    ConfirmImportDlgComponent,
    MessageDlgComponent,
    LedPreselectDialogComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    NgReduxModule,
    eSelectorRouterModule,
    EDSngCustomMaterialModuleModule,
    BrowserAnimationsModule,
    NgReduxRouterModule.forRoot(),
    FlexLayoutModule,
    NgxSliderModule,
    InViewportModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    })
  ],
  providers: [
    AuthService,
    ActionsService,
    LoadCatalogEpics,
    LoadProjectTypesEpics,
    AcceptSortSolutionsEpics,
    ValidationSpecsEpics,
    LoadUserInfoEpics,
    AnalyticsEpics,
    TestsEpics,
    AuthGuard,
    EDSngMediaService,
    ResetSpecsService,
    {provide: LocationStrategy, useClass: HashLocationStrategy}
    ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule {
  constructor(private ngRedux: NgRedux<ISelectorState>,
              private ngReduxRouter: NgReduxRouter,
              private devTools: DevToolsExtension,
              private catSvc: LoadCatalogEpics,
              private topSvc: LoadProjectTypesEpics,
              private solSvc: AcceptSortSolutionsEpics,
              private valSvc: ValidationSpecsEpics,
              private usrSvc: LoadUserInfoEpics,
              private gtagSvC: AnalyticsEpics,
              private test: TestsEpics) {

    let enhancers = [];
    // ... add whatever other enhancers you want.

    // You probably only want to expose this tool in devMode.
    // if (__DEVMODE__ && devTools.isEnabled()) {
    if (environment.production === false && devTools.isEnabled()) {
      enhancers = [ ...enhancers, devTools.enhancer() ];
    }
    const epicsMiddleware = createEpicMiddleware();
    const middlewares = [epicsMiddleware];
    const rootEpics = combineEpics(
     gtagSvC.sendPageInformation,
     gtagSvC.sendEventInformation,
     gtagSvC.sendException,
     gtagSvC.sendFeatureUpdate,
     topSvc.loadProjectTypes,
     topSvc.loadAppTypesMap,
     topSvc.updateBreadCrumbs,
     catSvc.loadCatalog,
     catSvc.loadFeatures,
     catSvc.loadLedDBCatalog,
     catSvc.selectDesignByKey,
     catSvc.logAllEvents,
     catSvc.importSpecificationFromWidget,
     catSvc.loadDescriptionsOfSelectedSolution,
     solSvc.listeningAcceptorActions,
     solSvc.acceptSolutions,
     solSvc.updateSolutions,
     solSvc.startCalcEfficiency,
     solSvc.calcEfficiency,
     solSvc.orderSolutions,
     solSvc.listeningResetLedSelection,
     valSvc.listeningValidateActions,
     valSvc.validateSpecs,
     usrSvc.loginUser,
     usrSvc.loadUserLogged,
     usrSvc.loadingUserData,
     usrSvc.loadUserDataCompleted,
     usrSvc.loadUserFile,
     usrSvc.setCurrentFolders,
     test.testCatalog,
    );

    this.ngRedux.configureStore(selectorRootReducer, SELECTOR_STATE_INIT,  middlewares, enhancers);

    epicsMiddleware.run(rootEpics);

    this.ngReduxRouter.initialize();
  }

}
